import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import { RadioButton } from "primereact/radiobutton";
import { useEffect, useState } from "react";
import { getUniqueFlatArr } from "./utils/utils";
import "./styles/style.scss";
import React from "react";
import { AggregationType, ChartType } from "./models/types";
import * as d3 from "d3";
import { IDataSet } from "./models/interfaces";
import { ColorPicker } from "primereact/colorpicker";
import { Divider } from "primereact/divider";

const SettingsDialog = ({
  displayDialog,
  selectedChartType,
  onHide,
  data,
  selectColorPalette,
  selectedColorPalette,
  selectAggregationMethod,
  aggregationMethod,
}: {
  displayDialog: boolean;
  selectedChartType: ChartType;
  onHide: any;
  data: IDataSet[];
  selectColorPalette: any;
  selectedColorPalette: { key: string; value: Array<any> };
  selectAggregationMethod: any;
  aggregationMethod: AggregationType;
}) => {
  const [selectedColors, setSelectedColors] = useState<{ key: string; value: Array<string> }>({ key: "", value: [] });
  const [pickedColor, setPickedColor] = useState<string>("1976D2");
  const [aggregationMethodTemp, setAggregationMethodTemp] = useState<AggregationType>("SUM");
  const colorSchemesArr: Array<any> = [];
  let niceColorName = "";

  for (const [key, value] of Object.entries(d3)) {
    if (key.includes("scheme")) {
      niceColorName = key.replace("scheme", "");
      colorSchemesArr.push({ niceColorName, value });
    }
  }

  useEffect(() => {
    setSelectedColors(selectedColorPalette);
  }, [selectedColorPalette]);

  const handleSelectColorPalette = (e: { value: string }) => {
    const colorPaletteObj = colorSchemesArr.find((c) => c.niceColorName === e.value);
    colorPaletteObj.value = getUniqueFlatArr(colorPaletteObj.value);
    setSelectedColors(colorPaletteObj);
  };

  const handleEditColor = (e: any, i: number) => {
    e.preventDefault();
    if (selectedColors !== undefined) {
      const paletteCloneArr = JSON.parse(JSON.stringify(selectedColors?.value));
      paletteCloneArr[i] = `#${e.value}`;
      //paletteClone= {...paletteCloneArr[i], value: e.value};
      setSelectedColors({ ...selectedColors, value: paletteCloneArr });
    }
  };

  const Palette = () => {
    return (
      <div className="flex flex-row flex-wrap ml-3 p-0 justify-content-start">
        {selectedColors?.value.map((color, i) => {
          return (
            <svg key={i} className="w-3rem h-3rem">
              <circle cx={15} cy={15} r={15} fill={color} />
            </svg>
          );
        })}
      </div>
    );
  };

  const TracesColors = () => {
    return (
      <div className="flexColumn mt-3">
        {data.map((d, i) => {
          let colorIndex: number;
          if (i < selectedColors.value.length) {
            colorIndex = i;
          } else {
            colorIndex = i - selectedColors.value.length;
          }
          const color = selectedColors?.value[colorIndex];
          return (
            <div className="colorContainer" key={d.identifier}>
              <h6>{d.title}</h6>
              {/*       <svg key={i} className="colorIcon">
                <circle cx={15} cy={15} r={15} fill={color} />
              </svg> */}
              <ColorPicker tooltip={color} format="hex" className="colorIcon" value={color} onChange={(e) => handleEditColor(e, colorIndex)} />
            </div>
          );
        })}
      </div>
    );
  };

  const AggregationMethod = () => {
    const aggreagtionMethodsArr: Array<{ key: string; method: AggregationType }> = [
      { key: "SUM", method: "SUM" },
      { key: "AVG", method: "AVG" },
      //  { key: "none", method: "none" },
    ];
    return (
      <div className="flexRow center">
        <Divider align="left" className="mr-3">
          <h6 className="mr-3">Aggregation method selection:</h6>
        </Divider>
        {aggreagtionMethodsArr.map((m, index) => {
          return (
            <div key={m.key} className="flexRow center mr-3">
              <RadioButton
                inputId={m.key}
                name="aggregation method"
                value={m.method}
                onChange={(e) => setAggregationMethodTemp(e.value)}
                checked={aggregationMethodTemp == m.key}
              />
              <label htmlFor={m.key}>{m.method}</label>
            </div>
          );
        })}
      </div>
    );
  };

  const handleConfirm = () => {
    selectColorPalette(selectedColors);
    selectAggregationMethod(aggregationMethodTemp);
    onHide();
  };

  const renderFooter = () => {
    return (
      <div className="flex flex-row flex-wrap ml-3 p-0 justify-content-start sm-flex-column">
        <Button label="No" icon="pi pi-times" className="p-button-danger p-button-rounded" onClick={onHide} />
        <Button label="Yes" icon="pi pi-check" className="p-button-success p-button-rounded" onClick={handleConfirm} />
      </div>
    );
  };

  return (
    <Dialog header={`${selectedChartType} settings`} visible={displayDialog} className="dialog" footer={renderFooter()} onHide={() => onHide(false)}>
      {selectedChartType === "PIE" && <AggregationMethod />}
      <div className="flex md:flex-row sm:flex-column center">
        <Divider align="left" className="mr-3">
          <h6>Color palette selection:</h6>
        </Divider>
        <Dropdown
          value={selectedColorPalette?.key}
          options={colorSchemesArr.map((c) => c.niceColorName)}
          onChange={handleSelectColorPalette}
          placeholder="Select color palette"
          className="h-3rem"
        />

        {/*    <div className="flex mt-3">
          <Palette />
        </div> */}
      </div>
      <TracesColors />
    </Dialog>
  );
};

export default SettingsDialog;
